import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space } from "antd"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import moment from "moment"
import _, { cloneDeep } from 'lodash'

import '../css/OperateChangeRoom.css'

const { Option } = Select

interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface Prop {
    clientData?: Client
    storeID?: string,
    checkInRecordData?: checkInRecordData[]
    onChange?: () => void
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
    check_in_status: number // 0待分配 1已预订 2已入住 3已出所，整数类型
}

interface choiceDay {
    tag: string,
    date: string
}

interface roomDay {
    tag: string,
    date: string,
    color: string
    customer_name: string
}

interface roomDataType {
    room_id: string
    room_code: string
    situation_list: {
        "customer_name": string,
        "check_in_status": number,
        "check_in_start_day": string,
        "check_in_end_day": string,
        "check_in_total_days": number,
        "check_in_already_days": number,
        "check_in_left_days": number
    }[]
    dayData?: roomDay[]
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [roomTypeList, setRoomTypeList] = useState<{
        room_type_id: string,
        room_type_name: string
    }[]>([])

    const [startDay, setStartDay] = useState<any>()
    const [dayNum, setDayNum] = useState<number>()
    const [roomType, setRoomType] = useState<string>()
    const [direction, setDirection] = useState<number>()
    const [floor, setFloor] = useState<string>()
    const [hasWindow, setHasWindow] = useState<number>()

    const [allNeedDays, setAllNeedDays] = useState<number>(0)
    const [choiceDays, setChoiceDays] = useState<choiceDay[]>([])
    const [roomData, setRoomData] = useState<roomDataType[]>([])
    const [lastClickRoomID, setLastClickRoomID] = useState<string>()

    const [checkInList, setCheckInList] = useState<{
        room_id: string // 房间id
        check_in_start_day: string | undefined // 入住开始日期
        check_in_end_day: string | undefined // 入住结束日期
    }[]>([])

    const createTopDays = (day1: string, day2: string) => {
        let disDayNum = moment(day2).diff(day1, 'day')
        let days: choiceDay[] = []

        for (let i = 0; i <= disDayNum; i++) {
            days.push({ tag: '', date: '' })
        }

        days.forEach((el, index) => {
            el.tag = moment(day1).add(index, 'day').format("MM-DD")
            el.date = moment(day1).add(index, 'day').format("YYYY-MM-DD")
        })

        return days
    }

    const filterRoomColor = (roomList: roomDataType[], choiceDays: choiceDay[]) => {
        let list = cloneDeep(roomList)

        list.forEach(el => {
            el.dayData = []

            for (let i = 0; i < choiceDays.length; i++) {
                let color = ''
                let cName = ''
                let nowDate = choiceDays[i].date
                let nowTag = choiceDays[i].tag

                el.situation_list.forEach(situationEl => {
                    if (moment(nowDate) >= moment(situationEl.check_in_start_day) && moment(nowDate) <= moment(situationEl.check_in_end_day)) {
                        if (situationEl.check_in_status === 1) { // 1已预订#1890ff 2已入住 #ff4d4f
                            color = '#1890ff'

                        } else if (situationEl.check_in_status === 2) {
                            color = '#ff4d4f'

                        } else if (situationEl.check_in_status === 3) {
                            color = 'orange'
                        }
                    }

                    cName = situationEl.customer_name
                })

                el.dayData.push({ tag: nowTag, date: nowDate, color, customer_name: cName })
            }
        })

        return list
    }

    const searchRoom = () => {
        if (startDay) {
            baseAxiosNoInfo.get('/keeper/check_in/detail/change_room/query_can_order_room', {
                params: {
                    scene_type: 1, // 1调整房间 2续住
                    check_in_id: param.id,
                    new_check_in_date: startDay.format('YYYY-MM-DD'),
                    room_type_id: roomType,
                    direction,
                    floor,
                    has_window: hasWindow
                }
            }).then((res: any) => {
                clearChoice()

                if (res) {
                    setChoiceDays(createTopDays(res.change_start_date, res.change_end_date))
                    setRoomData(filterRoomColor(res.room_list, createTopDays(res.change_start_date, res.change_end_date)))
                    setAllNeedDays(moment(res.change_end_date).diff(moment(res.change_start_date), 'days'))
                }
            })

        } else {
            message.error('请先选择调整开始日期')
        }
    }

    useEffect(() => {
        if (prop.clientData) {
            // 查询房型
            baseAxiosNoInfo('/global/room_type_list_by_store', {
                params: {
                    store_id: prop.clientData?.store_id
                }
            }).then((res: any) => {
                res && setRoomTypeList(res)
            })

            // 查询房间信息
            baseAxiosNoInfo('/keeper/check_in/detail/room_info', {
                params: {
                    check_in_id: param.id
                }
            }).then((res: any) => {
                if (res) {
                    if (prop.clientData?.check_in_status === 1) {
                        setDayNum(prop.clientData.check_in_total_days)

                    } else if (prop.clientData?.check_in_status === 2 || prop.clientData?.check_in_status === 4) {
                        setStartDay(moment().add(1, 'day'))
                        setDayNum(prop.clientData.check_in_left_days)
                    }
                }
            })
        }
    }, [prop.clientData])

    const onFinish = () => {
        // 若是已预定，new_check_in_date必填

        // 如果第一个房间选择了多天，然后在第二个房间选择了1天
        let check_in_list = cloneDeep(checkInList)
        if (checkInList.length === 2 && !checkInList[1].check_in_end_day) {
            check_in_list[1].check_in_end_day = check_in_list[1].check_in_start_day
        }

        // 如果1个房间只续住一天
        if (checkInList.length === 1 && !checkInList[0].check_in_end_day) {
            check_in_list[0].check_in_end_day = check_in_list[0].check_in_start_day
        }

        // 如果2个房间各只续住一天
        if (checkInList.length === 2 && !checkInList[1].check_in_end_day) {
            check_in_list[1].check_in_end_day = check_in_list[1].check_in_start_day
        }

        baseAxiosComplete.post('/keeper/check_in/detail/change_room/submit', {
            check_in_id: param.id,
            new_check_in_date: startDay ? startDay.format('YYYY-MM-DD') : null,
            check_in_list
        }).then(res => {
            clearChoice()

            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    const clearChoice = () => {
        setLastClickRoomID(undefined)

        let rData = cloneDeep(roomData)
        rData.forEach(el => {
            el.dayData?.forEach(el => {
                if (el.color === '#52c41a') el.color = ''
            })
        })

        setRoomData(rData)
        setCheckInList([])
    }

    const ways = [undefined, '朝南', '朝北', '朝东', '朝西', '东南', '东北', '西南', '西北']

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 调整房间 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>调整房间</Button>

        <Modal className="change-room" title="调整房间" width={1700} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={6}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{prop.clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{prop.clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{prop.clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期/分娩日：</p>
                            <p>{prop.clientData?.expect_born_day}/{prop.clientData?.actually_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{prop.clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{prop.clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{prop.clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{prop.clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{prop.clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{prop.clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{prop.clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{prop.clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{prop.clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{prop.clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <div style={{ marginTop: 16 }}>
                <h4>调整开始日期</h4>
                <div style={{ marginTop: 8 }}>
                    <Space>
                        <DatePicker placeholder="开始日期" value={startDay} onChange={(v) => setStartDay(v)} />
                        <Input placeholder="天数" value={dayNum} onChange={(e: any) => setDayNum(e.target.value)} disabled={true} />
                    </Space>
                </div>

                <h4 style={{ marginTop: 16 }}>房间筛选</h4>
                <div style={{ marginTop: 8 }}>
                    <Space>
                        <Select virtual={false} style={{ width: 140 }} placeholder="房型" allowClear value={roomType} onChange={(v) => setRoomType(v)}>
                            {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option value={el.room_type_id}>{el.room_type_name}</Option>)}
                        </Select>
                        <Select placeholder="朝向" allowClear style={{ width: 140 }} value={direction} onChange={(v) => setDirection(v)}>
                            {ways.map((el: any, index: number) => el ? <Option value={index}>{el}</Option> : null)}
                        </Select>
                        <Input placeholder="楼层" value={floor} onChange={(e: any) => setFloor(e.target.value)} />
                        <Select placeholder="是否有窗" allowClear style={{ width: 140 }} value={hasWindow} onChange={(e: any) => setHasWindow(e)}>
                            <Option key={1} value={1}>有</Option>
                            <Option key={0} value={0}>没有</Option>
                        </Select>
                        <Button type="primary" onClick={searchRoom}>查询可预定房间</Button>
                    </Space>
                </div>
            </div>

            <div style={{ marginTop: 16 }}>
                <Space>
                    <div className="secs" style={{ width: 20, height: 20, background: '#fff', border: '1px solid #999' }}></div>
                    <span>空房</span>
                </Space>
                <Space style={{ marginLeft: 16 }}>
                    <div className="secs" style={{ width: 20, height: 20, background: '#1890ff' }}></div>
                    <span>已预订</span>
                </Space>
                <Space style={{ marginLeft: 16 }}>
                    <div className="secs" style={{ width: 20, height: 20, background: '#ff4d4f' }}></div>
                    <span>已入住</span>
                </Space>
            </div>

            <div>
                <div style={{ marginTop: 16 }}>
                    <Space>
                        <h4>已选天数：0</h4>
                        <Button style={{ marginBottom: 20, marginTop: 14 }} size="small" onClick={clearChoice}>清除选择日期</Button>
                    </Space>

                    <div className="dates clear">
                        {choiceDays.map(el => <div className="date-item fl" >{el.tag}</div>)}
                    </div>
                </div>

                <div style={{ marginTop: 16 }}>
                    {roomData.map((el: any, index) => <div>
                        <div className="clear">
                            <div className="room-number fl">{el.room_code}</div>

                            {el.dayData?.map((el2: any, index2: number) => <div className="room-item fl" style={{ background: el2.color, userSelect: 'none' }} onClick={() => {
                                if (el2.color.length === 0 || el2.color === '#1890ff') {
                                    let rData = cloneDeep(roomData)
                                    let oneDayData = rData[index].dayData
                                    let newCheckInList = cloneDeep(checkInList)

                                    if (checkInList.length === 0) { // 选择第一房间开始日期
                                        if (el2.date === choiceDays[0].date) {
                                            let check = {
                                                room_id: el.room_id, // 房间id
                                                check_in_start_day: el2.date, // 入住开始日期
                                                check_in_end_day: undefined, // 入住结束日期
                                            }

                                            newCheckInList.push(check)
                                            setCheckInList(newCheckInList)

                                            if (oneDayData) oneDayData[index2].color = '#52c41a'
                                            setRoomData(rData)
                                            setLastClickRoomID(el.room_id)

                                        } else {
                                            message.error('所选的第一个房间的第一个日期必须是可选日期的第一日期')
                                        }

                                    } else { // 第二次选择日期
                                        // 如果第一个房间只选择一天，然后在第二个房间选择了其他天数
                                        if (checkInList.length === 1 && checkInList[0].check_in_start_day && !checkInList[0].check_in_end_day && lastClickRoomID !== el.room_id) {
                                            let check = newCheckInList[0]
                                            check.check_in_end_day = check.check_in_start_day

                                            if (el2.date === moment(newCheckInList[0].check_in_end_day).add(1, 'day').format('YYYY-MM-DD')) {
                                                let check2 = {
                                                    room_id: el.room_id,//房间id
                                                    check_in_start_day: el2.date,//入住开始日期
                                                    check_in_end_day: undefined,//入住结束日期
                                                }

                                                newCheckInList.push(check2)
                                                setCheckInList(newCheckInList)

                                                if (oneDayData) oneDayData[index2].color = '#52c41a'
                                                setRoomData(rData)

                                            } else {
                                                message.error(' 所选第二个房间的第一日期必须紧跟第一房间的第二日期')
                                            }

                                            return
                                        }

                                        // 正常选择第一房间的结束日期
                                        if (checkInList.length === 1 && checkInList[0].check_in_start_day && !checkInList[0].check_in_end_day) {
                                            if (oneDayData) {
                                                oneDayData.forEach((el3, index3) => {
                                                    if (index2 >= index3) {
                                                        el3.color = '#52c41a'
                                                    }
                                                })

                                                setRoomData(rData)
                                            }

                                            let check = newCheckInList[0]
                                            check.check_in_end_day = el2.date

                                            setCheckInList(newCheckInList)
                                        }

                                        // 正常选择第二房间的开始日期
                                        if (checkInList.length === 1 && checkInList[0].check_in_start_day && checkInList[0].check_in_end_day) {
                                            if (el2.date === moment(checkInList[0].check_in_end_day).add(1, 'day').format('YYYY-MM-DD')) {
                                                let check = {
                                                    room_id: el.room_id,//房间id
                                                    check_in_start_day: el2.date,//入住开始日期
                                                    check_in_end_day: undefined,//入住结束日期
                                                }

                                                newCheckInList.push(check)
                                                setCheckInList(newCheckInList)

                                                if (oneDayData) oneDayData[index2].color = '#52c41a'
                                                setRoomData(rData)

                                            } else {
                                                message.error(' 所选第二个房间的第一日期必须紧跟第一房间的第二日期')
                                            }
                                        }

                                        // 正常选择第二房间的结束日期
                                        if (checkInList.length === 2 && checkInList[1].check_in_start_day && !checkInList[1].check_in_end_day) {
                                            if (allNeedDays === moment(el2.date).diff(moment(checkInList[0].check_in_start_day), 'day')) {
                                                if (oneDayData) {
                                                    oneDayData.forEach((el3, index3) => {
                                                        if (index2 >= index3 && moment(el3.date) > moment(checkInList[1].check_in_start_day)) {
                                                            el3.color = '#52c41a'
                                                        }
                                                    })

                                                    setRoomData(rData)
                                                }

                                                let check = newCheckInList[1]
                                                check.check_in_end_day = el2.date

                                                setCheckInList(newCheckInList)

                                            } else {
                                                message.error('所选总的天数需要和预定天数一致')
                                            }
                                        }
                                    }
                                } else {
                                    message.error('此房间当前日期不可选， 已入住或已出所。')
                                }
                            }}>{el2.tag}</div>)}
                        </div>
                    </div>)}
                </div>
            </div>
        </Modal>
    </Fragment>
}